import routerOptions0 from "/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/node_modules/.pnpm/nuxt@3.13.2_@types+node@18.19.54_typescript@5.6.2_vite@5.4.8_vue-tsc@2.1.6/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}